





































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuporteSecretariasStore, { HospitalSecretaria, TipoUsuarioAgendamento } from '@/components/Suporte/Store/SuporteSecretariasStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { onlyNumber, validateCPF, validateEmail, validateTelefone } from '@/utils/common'

@Component
export default class ModalSuporteSecretaria extends Vue {
  loadSaveOrUpdateSecretaria: boolean = false
  loadLocaisAtendimento: boolean = false

  get getSuporteSecretariasStore() {
    return getModule(SuporteSecretariasStore, this.$store)
  }

  get loadingLocaisAtendimento() { return this.loadLocaisAtendimento }
  set loadingLocaisAtendimento(value: boolean) { this.loadLocaisAtendimento = value }

  get loadingSaveOrUpdateSecretaria() { return this.loadSaveOrUpdateSecretaria }
  set loadingSaveOrUpdateSecretaria(value: boolean) { this.loadSaveOrUpdateSecretaria = value }

  get showModalSecretaria() { return this.getSuporteSecretariasStore.modal.secretaria }
  set showModalSecretaria(value: boolean) { this.getSuporteSecretariasStore.setModal({ name: 'secretaria', value }) }

  get mode() { return this.getSuporteSecretariasStore.mode }
  get listaTipoUsuarioAgendamento() {
    return this.mode === 'CREATE'
      ? [
        { value: 'SecretariaDoAgendamento', text: 'Secretária do agendamento' },
        { value: 'SecretariaDoAmbulatorio', text: 'Secretária do ambulatório' },
      ]
      : [
        { value: 'SecretariaDoAgendamento', text: 'Secretária do agendamento' },
        { value: 'SecretariaDoAmbulatorio', text: 'Secretária do ambulatório' },
        { value: 'SecretariaDoMedico', text: 'Secretária do médico' },
      ]
  }

  $refs!: { formSecretaria: any }

  formSecretariaRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    documento: [(v: any) => this.validateCpfType(v)],
    email: [(v: any) => this.validateEmailType(v)],
    telefone: [(v: any) => this.validateTelephoneType(v)],
    tipoUsuarioAgendamento: [(v: any) => !!v || 'Campo obrigatório.'],
    dataNascimento: [(v: any) => !!v || 'Campo obrigatório.'],
    sexo: [(v: any) => !!v || 'Campo obrigatório.'],
    hospitais: [],
  }

  validateCpfType(cpfValue: any) {
    if (['', null, undefined].includes(cpfValue)) return 'Campo obrigatório.'
    if (!validateCPF(cpfValue)) return 'CPF inválido.'
    return false
  }

  validateEmailType(value: any) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (!validateEmail(value)) return 'E-mail inválido.'
    return false
  }

  validateTelephoneType(value: any) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (!validateTelefone(value)) return 'Telefone inválido.'
    return false
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  resetTipoUsuarioAgendamento(tipoUsuarioAgendamento: string) {
    switch (tipoUsuarioAgendamento) {
      case TipoUsuarioAgendamento.SecretariaDoAgendamento:
        console.log(tipoUsuarioAgendamento)
        return
      case TipoUsuarioAgendamento.SecretariaDoAmbulatorio:
        console.log(tipoUsuarioAgendamento)
        return
      default:
        console.log(tipoUsuarioAgendamento)
    }
  }

  async getAllLocaisAtendimentoByHospitalId(hospital: HospitalSecretaria[]) {
    this.loadingLocaisAtendimento = true
    const payload = hospital.map((item: any) => item.hospitalId)
    const response = await this.getSuporteSecretariasStore.getAllLocaisAtendimentoByHospitalId([payload[payload.length - 1]])
    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar locais de atendimento ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingLocaisAtendimento = false
  }

  async saveOrUpdateSecretaria() {
    if (!this.$refs.formSecretaria.validate()) return
    this.loadingSaveOrUpdateSecretaria = true
    const { mode } = this.getSuporteSecretariasStore
    const response = await this.getSuporteSecretariasStore.upsertSecretaria()

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} a secretaria ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingSaveOrUpdateSecretaria = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Secretária ${mode === 'CREATE' ? 'criada' : 'alterada'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    await this.getSuporteSecretariasStore.getSecretariaPagedSearch(this.getSuporteSecretariasStore.paginationSecretaria)
    this.showModalSecretaria = false
    this.loadingSaveOrUpdateSecretaria = false
  }

  @Watch('showModalSecretaria')
  onChangeShowModalSecretaria(value: boolean) {
    if (!value) {
      this.loadingLocaisAtendimento = false
      this.getSuporteSecretariasStore.clearSecretaria()
      this.getSuporteSecretariasStore.setMode('CREATE')
      this.$refs.formSecretaria.resetValidation()
    }
  }
}
